import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidatorFn, UntypedFormControl, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[validatePercentage][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: ValidatePercentageDirective, multi: true }
  ]
})
export class ValidatePercentageDirective implements Validator {
  validator: ValidatorFn;

  @Input('validatePercentage') validatePercentage: string = null;
  constructor() {
    this.validator = this.validateFunction();
  }

  validate(c: UntypedFormControl) {
    return this.validator(c);
  }

  validateFunction(): ValidatorFn {
    return (c: AbstractControl) => {

      if (this.validatePercentage.indexOf("PERCENTAGE") == -1)
        return null;

      let isValid = (c.value <= 100 && c.value >= 0);

      if (isValid) {
        return null;
      } else {
        return {
          percentage: {
            valid: false
          }
        };
      }
    }
  }
}
